<template>
  <div>
    <div class="button-item mt-1 ml-2">
      <router-link
        :to="{ 
            name: 'Tariff Edit',
            params: { id: getId(), 
            tariffName: getName(),
            description:getDescription(),
            value:getValue(),
            price:getPrice(), 
            active:getActive()}}"
      >
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="cursor-pointer"></feather-icon>
      </router-link>
    </div>

    <div class="button-item mt-1">
      <feather-icon
        @click="popupActive = true"
        icon="XCircleIcon"
        svgClasses="h-5 w-5 ml-5"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-popup
      classContent="popup-example"
      :title="$t('areYouSureDelete')"
      :active.sync="popupActive"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <vs-button @click="deleteTariff(getId())" color="danger">{{ $t('yes') }}</vs-button>
            <vs-button @click="popupActive = false" style="margin-left:75px">{{ $t('no') }}</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import http from "../../../../http/http-helper";
export default Vue.extend({
  props: ["id", "tariffName", "description", "value", "price", "active"],
  data() {
    return {
      popupActive: false
    };
  },
  methods: {
    getId() {
      return this.id;
    },
    getName() {
      return this.tariffName;
    },
    getDescription() {
      return this.description;
    },
    getValue() {
      return this.value;
    },
    getPrice() {
      return this.price;
    },
    getActive() {
      return this.active;
    },
    // Delete Tariff
    deleteTariff(id) {
      let path = "/tariffs/delete?tariffId=" + id;
      this.$vs.loading();
      http.get(path).then(response => {
        this.popupActive = false;
        this.$emit("refresh");
        this.$vs.notify({
          title: this.$t("removed"),
          color: "success"
        });
      });
    }
  }
});
</script>
<style scoped>
.button-item {
  display: inline-block;
}
</style>
